import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { c } from '@debbie/cortex/dist/index.js';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors.js';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors.js';
import { Checkbox } from '../../index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const WorkflowsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const workflows = useSelector(selectWorkflows);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    useEffect(() => {
        if (!workflows) {
            c.workflows.getAll();
        }
    }, []);
    const inWorkflowIds = caseFilter.inWorkflowIds;
    const selectedWorkflows = inWorkflowIds
        ? workflows?.filter((workflow) => inWorkflowIds.includes(workflow.workflowId))
        : workflows;
    const tasks = selectedWorkflows
        ?.reduce((acc, workflow) => {
        for (let i = 0; i < workflow.tasks.length; i++) {
            const task = workflow.tasks[i];
            const updateType = updateTypesMap && updateTypesMap[task.updateTypeId];
            if (updateType) {
                acc = acc.concat({
                    task,
                    updateType,
                    position: task.position,
                });
            }
        }
        return acc;
    }, [])
        .sort((a, b) => a.position.y - b.position.y);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.workflowsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.inWorkflowIds && caseFilter.inWorkflowIds.length), header: lang.caseFilter.isInWorkflows, onDeactivate: () => c.insights.clearFilter('inWorkflowIds') },
            React.createElement(Select, { value: (caseFilter.inWorkflowIds || []).map((workflowId) => {
                    const workflow = workflows &&
                        workflows.find((workflow) => workflow.workflowId === workflowId);
                    return {
                        label: workflow?.title || workflowId,
                        value: workflowId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectWorkflows, classNamePrefix: "select", options: (workflows || []).map((workflow) => ({
                    label: workflow.title,
                    value: workflow.workflowId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        inWorkflowIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.nextTaskIds && caseFilter.nextTaskIds.length), header: lang.caseFilter.nextTaskIds, onDeactivate: () => c.insights.clearFilter('nextTaskIds') },
            React.createElement(Select, { value: (caseFilter.nextTaskIds || []).map((taskId) => {
                    const task = tasks && tasks.find(({ task }) => task.id === taskId);
                    return {
                        label: 
                        // @ts-ignore
                        lang.updateTypes[task?.task.updateTypeId] ||
                            task?.updateType?.label ||
                            taskId,
                        value: taskId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectNextTaskIds, classNamePrefix: "select", options: (tasks || []).map((task) => ({
                    label: lang.updateTypes[task?.task.updateTypeId] ||
                        task?.updateType?.label ||
                        task.task.id,
                    value: task.task.id,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        nextTaskIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.currentTaskIds && caseFilter.currentTaskIds.length), header: lang.caseFilter.currentTaskIds, onDeactivate: () => c.insights.clearFilter('currentTaskIds') },
            React.createElement(Select, { value: (caseFilter.currentTaskIds || []).map((taskId) => {
                    const task = tasks && tasks.find(({ task }) => task.id === taskId);
                    return {
                        label: 
                        // @ts-ignore
                        lang.updateTypes[task?.task.updateTypeId] ||
                            task?.updateType?.label ||
                            taskId,
                        value: taskId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCurrentTaskIds, classNamePrefix: "select", options: (tasks || []).map((task) => ({
                    label: lang.updateTypes[task?.task.updateTypeId] ||
                        task?.updateType?.label ||
                        task.task.id,
                    value: task.task.id,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        currentTaskIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.noNextTask === 'boolean', header: lang.caseFilter.noNextTask, onDeactivate: () => c.insights.clearFilter('noNextTask') },
            React.createElement(Checkbox, { onChange: (e) => {
                    c.insights.updateFilter({
                        noNextTask: e.target.checked,
                    });
                }, placeholder: lang.caseFilter.noNextTask, checked: !!caseFilter.noNextTask }))));
};
export default WorkflowsGroup;
//# sourceMappingURL=WorkflowsGroup.js.map